import styled from 'styled-components';
import spinner from "assets/animations/spinner.svg";

const Spinner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url(${spinner});
  background-size: 15% 15%;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
`;

export default Spinner;